import CSS from "./styles.module.css";

const Rating = ({ comment, person, company, className }) => {
	return (
		<div className={`${CSS.Rating} ${className}`}>
			<div className={CSS.Review}>
				<div className={CSS.Quotes}>"{comment}"</div>
				<div className={CSS.Footer}>
					<div className={CSS.Stars}>
						<span className="material-symbols-outlined">star</span>
						<span className="material-symbols-outlined">star</span>
						<span className="material-symbols-outlined">star</span>
						<span className="material-symbols-outlined">star</span>
						<span className="material-symbols-outlined">star</span>
					</div>
					<div className={CSS.Person}>
						- {person} ({company})
					</div>
				</div>
			</div>
		</div>
	);
};

export default Rating;
